export enum ACCOUNT_TYPE {
  ADMIN = 'admin'
}
